import { Vue, Component } from 'vue-property-decorator'
import gql from 'graphql-tag'

import {Dataset as DatasetType } from '@/@types/graphql'

@Component({ name: 'notification-service' })
export default class Dataset extends Vue {

    async GET_NOTIFICATION (): Promise<DatasetType> {
    const variables = { key: 'notification' }
    const query = gql`      
        query dataset ($key: String!) {
            dataset (key: $key) {
                value
            }
        }
    `
    const { data } = await this.$apollo.query({ query, variables })
    return data.dataset?.value
  }

}
